<template>
  <ProductBannerComponent
    v-if="tagText"
    :content="$t(tagText)"
    color="white"
    :background="!isPreorder ? 'secondary' : 'legacyTeal'"
    :data-testid="tagText"
    size="x-small"
    class="mr-1 px-2"
  />
</template>


<script lang="ts" setup>
import ProductBannerComponent from '~/components/base/ProductBanner.vue'
import { useShopStore } from '~/stores/shop'
import { LifeCycleState } from '~/types/lineitem'

interface Props {
  productOnSale?: boolean
  lifeCycleState?: string
  categorySlugs?: string[]
  exclusiveTo?: string[]
  qualifier?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  productOnSale: false,
  lifeCycleState: '',
  categorySlugs: () => [],
  exclusiveTo: () => [],
  qualifier: () => []
})

const shopStore = useShopStore()
const BUNDLED_SAVINGS = '/bundled-savings'

const isPreorder = computed(() => shopStore.isPreorder(props.qualifier))
const isBundleSaving = computed(() => props.categorySlugs.some((e: string) => e.includes(BUNDLED_SAVINGS)))
const isLastChance = computed(() => props.lifeCycleState === LifeCycleState.LASTCHANCE)

const tagText = computed(() => {
  if (isPreorder.value) {
    return 'product.tag.preorder'
  } else if (isLastChance.value) {
    return 'product.tag.lastChance'
  } else if (isBundleSaving.value) {
    return 'product.tag.bundleSaving'
  } else if (props.productOnSale) {
    return 'product.tag.sale'
  }
  return false
})
</script>

<style lang="scss" scoped>

</style>
